export const theme = {
  colors: {
    primary: {
      main: '#0b656aff',
      light: '#d2e9eaff',
    },
    secondary: {
      main: '#069094',
      light: '#ECF9FA',
    },
    misc: {
      w0: '#E6E6E6',
      w1: '#E7E7Ed',
      w2: '#272833',
      w3: '#D8E3E4',
      w4: '#EBECEF',
      w5: '#F7F8F9',
      w6: '#A7A9BC',
      w7: '#495057',
    },
  },
};
